module.exports = __webpack_public_path__ + "static/img/The Magician.2303bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Magician.jpg
// module id = 1319
// module chunks = 0